import React from 'react';

import * as filter from '_core/utils/filter';
import * as math from '_core/utils/math';


const DEFAULT_LIST = [];

const DEFAULT_MARK_PROPS = { className: 'highlight' };


export const filterList = (fields, list, query, props) => {
  if (!list)
    return DEFAULT_LIST;
  
  query = (String(query || '').trim() || null)
    ?.split(/[^a-zа-яё0-9]+/i)
    .filter((item) => item)
    .map((item) => ({ regexp: new RegExp(filter.regexp(item), 'gi') }));
  
  if (!query?.length)
    return list;
  
  let key = 0;
  
  return list
    .map((item) => {
      let found = false;
      
      const fieldList = Object.keys(fields).flatMap((field) => math.getFields(item, field));
      
      fieldList.forEach((path) => {
        const field = path[0];
        
        const text = String(field[1] || '').trim();
        
        if (!text.length)
          return;
        
        let regexps = query;
        
        if (!regexps.every((item) => item.exec = item.regexp.exec(text)))
          return;
        
        found = true;
        
        const highlight = [];
        
        let index = 0;
        
        do {
          regexps.sort((item1, item2) => item1.exec.index - item2.exec.index);
          
          const exec = regexps[0].exec;
          
          const length = exec[0].length;
          
          highlight.push(text.substring(index, exec.index));
          
          highlight.push((
            <mark key={'search-' + (++key)} {...(props ?? DEFAULT_MARK_PROPS)}>
              {text.substring(exec.index, exec.index + length)}
            </mark>
          ));
          
          index = exec.index + length;
          
          regexps.forEach((item) => item.regexp.lastIndex = index);
          
          regexps = regexps.filter((item) => item.exec = item.regexp.exec(text));
        } while (regexps.length);
        
        highlight.push(text.substring(index));
        
        field.push(highlight);
      });
      
      if (!found)
        return null;
      
      item = math.deepCopy(item);
      
      fieldList.forEach((path) => {
        if (!path[0][2])
          return;
        
        const setPath = path.map((field) => field[0]).filter((field) => field !== undefined);
        
        setPath[0] += 'Highlight';
        
        math.setFields(item, setPath.reverse(), path[0][2]);
      });
      
      return item;
    })
    .filter((value) => value);
};
